// extracted by mini-css-extract-plugin
module.exports = {"mount":"global__mount__cToMU","diploma":"global__diploma__3Q8A2"};